import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import {Card, Row, Col, Collapse, Table} from 'antd';

export default class obliqueContent2 extends React.Component {


    render() {
        const cardStyle = {
            width: 420,
            padding: 8,
            margin: "0 auto",
            border:"none"
        }
        const columns = [
            {
                title: '',
                dataIndex: 'name',
                key: 'name',
                align: 'center',
            },
            {
                title: 'DG3M',
                dataIndex: 'DG3M',
                key: 'DG3M',
                align: 'center',
            },
            {
                title: 'DG4M',
                dataIndex: 'DG4M',
                key: 'DG4M',
                align: 'center',
            },
        ];

        const data = [
            {
                key: '1',
                name: '镜头数量',
                DG4M:'5',
                DG3M:'5',
            },
            {
                key: '2',
                name: '焦距',
                DG3M: '正射30mm/倾斜45mm',
                DG4M:'正射40mm/倾斜56mm',
            },
            {
                key: '3',
                name: '有效像素',
                DG4M:'42MP, 总像素≥2.1亿',
                DG3M:'24MP, 总像素≥1.2亿',
            },
            {
                key: '4',
                name: '像素尺寸',
                DG3M: 'APS-C（23.5mm×15.6mm）',
                DG4M:'全画幅（35.9mm×24mm）',
            },
            {
                key: '5',
                name: '摄像头角度',
                DG3M: '45°',
                DG4M:'45°',
            },
            {
                key: '6',
                name: '曝光间隔',
                DG3M: '≤0.8s',
                DG4M:'≥0.8s',
            },
            {
                key: '7',
                name: '硬盘储存空间',
                DG3M: '640GB/1280GB',
                DG4M:'1280GB',
            },
            {
                key: '8',
                name: '数据读取',
                DG3M: 'Sky-scanner高级版',
                DG4M:'Sky-scanner高级版',
            },
            {
                key: '9',
                name: '电池 开/关',
                DG3M: '自动 开/关',
                DG4M:'自动 开/关',
            },
            {
                key: '10',
                name: '工作温度',
                DG3M: '-10°C-50°C',
                DG4M:'-10°C-50°C',
            },
            {
                key: '11',
                name: '湿度',
                DG3M: '90%',
                DG4M:'90%',
            },
            {
                key: '12',
                name: '尺寸',
                DG3M: '160x160x105mm',
                DG4M:'160x160x105mm',
            },
            {
                key: '13',
                name: '重量',
                DG3M: '1350g',
                DG4M:'1350g',
            },
        ];
        return (
            <div className='oblique-content2'>
                <QueueAnim
                    key="QueueAnim"
                    type={['bottom', 'top']}
                    delay={200}
                    className='banner0-text-wrapper'
                >

                    <Table key={"table"} columns={columns} dataSource={data} pagination={false}/>
                </QueueAnim>
            </div>
        )

    }
}
